import React, { useRef, useState } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faSquarePlus, faCircleExclamation, faTrashCan, faMinus, faHome, faCaretSquareLeft, faCaretSquareRight, faFolderTree } from '@fortawesome/free-solid-svg-icons';
import { Box, Button, Checkbox, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Select, Spinner, Tag } from '@chakra-ui/react';
import { complete_sankey_data, compute_default_input_outputLinksId, Counter, DefaultLink, DefaultNode, MenuDraggable, OSTooltip, SplitTrade } from '../import/OpenSankey';
import { LinkVisible, GetDataFromView } from '../FunctionOSTyped';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { CreateViewNodeUnitary } from './UnitarySankeyCreate';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { NodeHasDisplayedLevel } from 'open-sankey/dist/configmenus/SankeyUtils';
const logo_unit_process_transfo = React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 1000 1000" },
    React.createElement("g", null,
        React.createElement("path", { d: "M 5.9497609,925.95372 C -4.5505643,898.59029 174.15641,385.43615 207.7775,346.40863 c 15.11437,-17.54486 44.31129,-26.22296 88.22545,-26.22296 60.24819,0 64.36204,-2.37881 50.12343,-28.98395 -34.65058,-64.74517 -4.1459,-170.55878 62.65945,-217.351077 18.36384,-12.862528 59.53485,-23.386413 91.49116,-23.386413 114.6541,0 198.53078,139.75294 144.48545,240.73749 -14.20756,26.5471 -10.11306,29.00324 48.69973,29.21341 35.31627,0.12593 72.75035,5.64955 83.18679,12.27401 24.6669,15.65717 227.23974,572.12519 217.5062,597.49016 -5.85902,15.26824 -110.04595,19.35647 -493.29195,19.35647 -428.177117,0 -486.938597,-2.79993 -494.9134491,-23.58205 z M 959.96469,913.28941 c 0,-3.45253 -43.82976,-126.14482 -97.39944,-272.64964 -53.56969,-146.50481 -97.39939,-268.42617 -97.39939,-270.93639 0,-2.51028 -47.20129,-4.56409 -104.8917,-4.56409 -110.0788,0 -123.20273,-8.75297 -76.49805,-51.02008 62.3297,-56.40765 44.96468,-173.27409 -31.63209,-212.88383 C 429.11754,37.615914 316.99725,196.72961 405.53726,309.29 c 16.48298,20.95469 29.96905,42.09317 29.96905,46.97435 0,4.88124 -46.21242,8.87494 -102.69428,8.87494 H 230.11774 L 138.0132,620.99887 C 87.355715,761.72162 45.908666,886.46785 45.908666,898.21258 c 0,18.0157 71.449614,21.35416 457.027984,21.35416 251.36543,0 457.02804,-2.82481 457.02804,-6.27733 z M 332.2502,664.82976 c 51.31553,-74.17337 102.68186,-134.86069 114.14741,-134.86069 24.56551,0 24.22186,0.641 -82.33,153.59135 -44.49571,63.87157 -90.85011,116.13011 -103.00982,116.13011 -14.21486,0 11.20386,-48.15104 71.19241,-134.86077 z m 49.22254,113.64977 c -4.47668,-11.66609 -5.95082,-40.32401 -3.27585,-63.68429 4.09089,-35.72541 11.74597,-42.47322 48.18406,-42.47322 56.85567,0 80.84917,37.13689 57.33566,88.74349 -19.55758,42.92415 -87.98262,54.57822 -102.24387,17.41402 z m 69.0181,-46.21938 c 0,-38.25773 -20.45211,-49.99828 -37.9048,-21.75923 -12.46509,20.16899 2.339,59.22054 22.44998,59.22054 8.50016,0 15.45482,-16.85761 15.45482,-37.46131 z m 164.82976,52.44582 c 0,-8.2415 13.48606,-14.98451 29.96906,-14.98451 26.38037,0 29.96906,-9.98971 29.96906,-83.42467 0,-76.60558 -2.44966,-82.64715 -29.96906,-73.91283 -40.22052,12.76549 -38.11612,-15.071 3.33415,-44.10393 62.096,-43.49373 71.58848,-31.68495 71.58848,89.05748 0,102.39424 2.66391,112.38395 29.96901,112.38395 16.48299,0 29.96906,6.74301 29.96906,14.98451 0,8.24149 -37.08669,14.98456 -82.41488,14.98456 -45.32819,0 -82.41488,-6.74307 -82.41488,-14.98456 z M 231.6275,643.61876 c -4.47669,-11.66603 -5.95083,-40.32393 -3.27586,-63.68421 4.09089,-35.72547 11.74598,-42.47322 48.18406,-42.47322 56.85569,0 80.84919,37.13683 57.33565,88.74347 -19.55757,42.92415 -87.98262,54.57816 -102.24385,17.41396 z m 69.01809,-46.21937 c 0,-38.25772 -20.45211,-49.99822 -37.90479,-21.75922 -12.4651,20.16899 2.33899,59.22053 22.44998,59.22053 8.50015,0 15.45481,-16.85754 15.45481,-37.46131 z M 435.50631,290.21666 c -58.20116,-58.20119 -20.37983,-164.8298 58.46537,-164.8298 85.65086,0 127.30456,122.98327 58.07669,171.47235 -44.82294,31.39521 -80.54006,29.35943 -116.54206,-6.64255 z m 104.2949,-36.74224 c 37.96518,-45.74527 -23.70748,-118.92546 -68.73283,-81.55773 -21.3863,17.74903 -27.98661,75.92696 -10.58785,93.32576 17.28971,17.28964 60.52889,10.87471 79.32068,-11.76803 z" })));
// Return button in context menu of node to create a unitary view with the contextualised node
export const context_node_view_node_unitary = (applicationContext, applicationData, contextMenu, applicationState) => {
    const { t } = applicationContext;
    if (applicationData.master_data === undefined) {
        applicationData.master_data = JSON.parse(JSON.stringify(applicationData.data));
    }
    const { ref_contextualised_node } = contextMenu;
    // Search if master data has view with unitary sankey
    // const has_unitary_view = master_data && master_data!.view?.filter(v => {
    //   if ((v.view_data as DiffType).diff !== undefined) {
    //     return (v.view_data as DiffType)
    //       .diff
    //       .filter(vo => vo.path!.includes('unitary_node')).length > 0
    //   }
    //   else {
    //     return (v.view_data as SankeyDevData).unitary_node.length > 0
    //   }
    // }).length > 0
    // // Create a function that filter view to know if they are a unitary view
    // // It detect if the view has unitary_node wich is a variable used in unitary sankey
    // const is_unitary_view = (v: DevViewType) => {
    //   if ((v.view_data as DiffType).diff !== undefined) {
    //     return (v.view_data as DiffType).diff.filter(vo => vo.path!.includes('unitary_node')).length > 0
    //   } else {
    //     return (v.view_data as SankeyDevData).unitary_node.length > 0
    //   }
    // }
    //if (data.unitary_node && data.unitary_node.length === 0) {
    return React.createElement(Menu, { placement: 'end' },
        React.createElement(MenuButton, { variant: 'contextmenu_button', as: Button, rightIcon: React.createElement(ChevronRightIcon, null), className: "dropdown-basic" },
            t('view.unit_node'),
            React.createElement(Tag, { colorScheme: 'teal', style: { marginLeft: 'auto' } }, "Dev")),
        React.createElement(MenuList, null,
            React.createElement(MenuItem, { onClick: () => {
                    applicationState.multi_selected_nodes.current = [];
                    if (Object.values(applicationData.data.nodes).length === 0) {
                        return;
                    }
                    CreateViewNodeUnitary(t, applicationData, ref_contextualised_node.current, true /*from_zdd*/);
                    applicationData.set_master_data(Object.assign({}, applicationData.master_data));
                } }, t('view.in_new'))));
    // } else if (data.unitary_node && data.unitary_node.length > 0) {
    //   return <Button onClick={() => {
    //     data.unitary_node = []
    //     set_data({ ...data })
    //   }} variant='contextmenu_button'>{t('view.to_normal_view')} </Button>
    // } else {
    //   return <></>
    // }
};
export const ModalUnitarySankeySpecialLinkValue = ({ applicationData, dict_hook_ref_setter_show_dialog_components, t }) => {
    const { data, set_data, display_nodes } = applicationData;
    const dev_data = data;
    const [search_in_input_or_output, set_search_in_input_or_output] = useState('inputLinksId'); // useState not OK
    const unitary_nodes = Object.values(data.nodes).filter(n => n.inputLinksId.length > 0 && n.outputLinksId.length > 0);
    const unitary_node = unitary_nodes.length == 1 ? unitary_nodes[0] : undefined;
    if (!unitary_node) {
        return React.createElement(React.Fragment, null);
    }
    if (data.style_link['SankeyUnitaryInputLinkStyle'] == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return MenuDraggable(dict_hook_ref_setter_show_dialog_components, 'ref_setter_show_modal_edit_link_reference_unitary', React.createElement(Box, { layerStyle: 'menuconfigpanel_grid' },
        React.createElement(Checkbox, { variant: 'menuconfigpanel_option_checkbox', isChecked: data.style_link['SankeyUnitaryInputLinkStyle'].unit_link_value_display === 'value', onChange: () => {
                data.style_link['SankeyUnitaryInputLinkStyle'].unit_link_value_display = 'value';
                data.style_link['SankeyUnitaryOutputLinkStyle'].unit_link_value_display = 'value';
                set_data(Object.assign({}, data));
            } }, t('view.unit_sankey_values_links')),
        React.createElement(Checkbox, { variant: 'menuconfigpanel_option_checkbox', isChecked: data.style_link['SankeyUnitaryInputLinkStyle'].unit_link_value_display === 'percent', onChange: () => {
                data.style_link['SankeyUnitaryInputLinkStyle'].unit_link_value_display = 'percent';
                data.style_link['SankeyUnitaryOutputLinkStyle'].unit_link_value_display = 'percent';
                set_data(Object.assign({}, data));
            } }, t('view.unit_sankey_percent_links')),
        React.createElement(Box, null,
            React.createElement(Checkbox, { variant: 'menuconfigpanel_option_checkbox', isChecked: data.style_link['SankeyUnitaryInputLinkStyle'].unit_link_value_display === 'normalize', onChange: () => {
                    data.style_link['SankeyUnitaryInputLinkStyle'].unit_link_value_display = 'normalize';
                    data.style_link['SankeyUnitaryOutputLinkStyle'].unit_link_value_display = 'normalize';
                    set_data(Object.assign({}, data));
                } }, t('view.unit_sankey_normalize_links'))),
        React.createElement("hr", null),
        React.createElement(Box, { as: 'span', layerStyle: 'menuconfigpanel_row_3cols' },
            React.createElement(Box, { layerStyle: 'menuconfigpanel_option_name' }, t('view.chose_io')),
            React.createElement(Button, { variant: search_in_input_or_output === 'inputLinksId' ? 'primary' : 'outline-primary', onClick: () => {
                    set_search_in_input_or_output('inputLinksId');
                } }, t('view.input_link')),
            React.createElement(Button, { variant: search_in_input_or_output === 'outputLinksId' ? 'primary' : 'outline-primary', onClick: () => {
                    set_search_in_input_or_output('outputLinksId');
                } }, t('view.output_link'))),
        React.createElement(Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols' },
            React.createElement(Box, { layerStyle: 'menuconfigpanel_option_name' }, t('view.chose_link_ref')),
            React.createElement("div", { style: { width: '50%' } },
                React.createElement(MultiSelect, { className: 'multidropdown_select_link_ref', 
                    // style={{ width:'50%' }}
                    labelledBy: 'dropdown_link_filter', overrideStrings: {
                        'selectAll': 'Tout sélectionner',
                    }, value: unitary_node ? unitary_node[search_in_input_or_output]
                        .filter(lid => dev_data.links[lid].is_ref_value)
                        .map(lid => {
                        const src_name = data.nodes[data.links[lid].idSource].name;
                        const trgt_name = data.nodes[data.links[lid].idTarget].name;
                        return { 'label': src_name + '--->' + trgt_name, 'value': lid };
                    }) : [], options: unitary_node ? unitary_node[search_in_input_or_output]
                        .filter(lid => LinkVisible(data.links[lid], data, display_nodes))
                        .map(lid => {
                        const src_name = data.nodes[data.links[lid].idSource].name;
                        const trgt_name = data.nodes[data.links[lid].idTarget].name;
                        return { 'label': src_name + '--->' + trgt_name, 'value': lid };
                    }) : [], onChange: (selected) => {
                        //data.process_transfo_ref[selected_node_to_configure] = []
                        Object.values(dev_data.links).forEach(l => l.is_ref_value = false);
                        selected.forEach(s => {
                            dev_data.links[s.value].is_ref_value = true;
                        });
                        set_data(Object.assign({}, data));
                    } })))), { current: [window.innerWidth / 4, window.innerHeight / 4] }, t('view.view_title_modal_select_link_ref_in_unitary_sankey'));
};
// interface RawSankeyNodeDatum extends RawNodeDatum {
//   id: string
//   selected: boolean
//   children?: RawSankeyNodeDatum[]
// }
// // Recursive function used to return children ( and sub-children) of node in the creation of the tree-list of nodes
// const add_children = (nodes: { [x: string]: SankeyDevNode }, n: SankeyDevNode, filter_node_selector: string[], filter_name: string, selected_nodes_excel: SankeyDevNode[]) => {
//   const children: RawSankeyNodeDatum[] = []
//   Object.entries(nodes)
//     .filter(n => check_node_has_node_type(n, filter_node_selector))
//     .forEach(nn => {
//       if (nn[1].dimensions) {
//         Object.entries(nn[1].dimensions).filter(nd => nd[0] === 'Primaire' && nd[1].parent_name === n.idNode).forEach(() => {
//           const c: RawSankeyNodeDatum = { id: nn[0], name: nn[1].name, selected: selected_nodes_excel.includes(nn[1]) }
//           const child = add_children(nodes, nn[1], filter_node_selector, filter_name, selected_nodes_excel)
//           if (child.length !== 0) {
//             c.children = child
//           }
//           if (c.children || (!c.children && (c.name.toLocaleLowerCase()).includes(filter_name.toLocaleLowerCase()))) {
//             children.push(c)
//           }
//         })
//       }
//     })
//   return children
// }
// Return a list of nodes formated to be used in FolderTree component, the tree reprensent the aggregation tree of nodes
// const tree_data_nodes = (data: SankeyDevData, filter_node_selector: string[], filter_name: string, selected_nodes_excel: SankeyDevNode[]) => {
//   const tree_root = { id: 'root', name: 'Root', children: [], selected: false } as RawSankeyNodeDatum
//   const roots_nodes = Object.values(data.nodes).filter(n=>n.tags['Primaire'] === undefined || n.tags['Primaire'].includes('1'))
//   roots_nodes.filter(n => check_node_has_node_type(n, filter_node_selector)).forEach(n => {
//     const sub_tree = { id: n.idNode, name: n.name, selected: selected_nodes_excel.includes(n) }
//     tree_root.children?.push(sub_tree)
//     tree_root.children?.forEach(t => {
//       const child_t = add_children(data.nodes, data.nodes[t.id], filter_node_selector, filter_name, selected_nodes_excel)
//       if (child_t.length > 0) {
//         t.children = child_t
//       }
//     })
//     tree_root.children = tree_root.children?.filter(ct => {
//       return ct.children || (!ct.children && (ct.name.toLocaleLowerCase()).includes(filter_name.toLocaleLowerCase()))
//     })
//   })
//   return tree_root
// }
// interface SankeyTreeNodeDatum extends TreeNodeDatum {
//   id: string,
//   selected: boolean
// }
// interface SankeyCustomNodeElementProps extends CustomNodeElementProps {
//   nodeDatum: SankeyTreeNodeDatum
// }
const width_text_zone = 8;
// In the future create a style for the element rendered in this function
// function to override default tree render of nodes so we can add color to node according to their place in the tree
// const renderRectSvgNode: RenderCustomNodeElementFn = ({ nodeDatum, toggleNode }) => {
//   const extendedNodeDatum = nodeDatum as SankeyTreeNodeDatum
//   let color_node = '#25B48C'
//   if (extendedNodeDatum.selected) {
//     color_node = '#ffb02b'
//   } else if (extendedNodeDatum.children) {
//     color_node = '#0d006f'
//   }
//   return <g>
//     <circle r="10" style={{ fill: color_node, stroke: color_node }} onClick={toggleNode} />
//     <foreignObject y={extendedNodeDatum.children ? '-25' : '5'} x={extendedNodeDatum.children ? '25' : (-width_text_zone / 2) + 'rem'} style={{ width: '10rem', height: '100%', textAlign: 'center' }}>
//       <div style={{ width: width_text_zone + 'rem', whiteSpace: 'normal' }} >
//         <text fill="black" strokeWidth="1" textAnchor='middle'    >
//           {extendedNodeDatum.name}
//         </text>
//       </div>
//     </foreignObject>
//   </g>
// }
// Banner to create unitary view
// It is similar to OSPBannerView but specialised in the creation of unitary view
// It contain :
// - a button to return to master_data
// - a button to create a unitary view after selecting a node in a tree-list
// - a button to open a modal where we import data from excel file then create unitary views after selecting nodes in a tree-list
// - a button to save the modification of the current view
// - 2 buttons to switch between views (even not unitary view)
// - a selector to switch view
// - a button to delete the current view
// - a button to open the modal used to select links for reference in the display of link value (only appear of the unitary node is a sector)
export const SankeyDevBannerUnit = ({ applicationData, t, connected, dict_hook_ref_setter_show_dialog_components, view_selector }) => {
    const { data, master_data, view, set_view, set_data, set_master_data } = applicationData;
    const m_d = master_data ? master_data : data;
    const has_views = master_data ? master_data.view.length > 0 : false;
    const next_button_disabled = m_d.view && (m_d.view.map(d => d.id).indexOf(view) === m_d.view.length - 1);
    const prev_button_disabled = m_d.view && (m_d.view.map(d => d.id).indexOf(view) === 0 || view === 'none');
    return React.createElement(React.Fragment, null,
        React.createElement(OSTooltip, { label: (!connected && !has_views) ? t('Menu.sankeyOSPDisabled') : t('view.tooltips.home') },
            React.createElement(Button, { variant: 'menutop_button', disabled: ((!connected && !has_views) || (master_data && master_data.is_catalog)), onClick: () => {
                    const ev = document;
                    const tmp = { key: 'F7' };
                    if (ev.onkeydown) {
                        ev.onkeydown(tmp);
                    }
                } },
                React.createElement(Box, { layerStyle: 'menutop_button_style' },
                    React.createElement(Box, { gridRow: "1", padding: "0.1rem 0 0.1rem 0" },
                        React.createElement(FontAwesomeIcon, { style: { 'height': '2rem', 'width': '3rem' }, icon: faHome }),
                        (!connected && !has_views) ?
                            React.createElement(FontAwesomeIcon, { icon: faLock, style: {
                                    fontSize: '1em',
                                    position: 'absolute',
                                    right: '0.1em',
                                    bottom: '0em',
                                    color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                } }) :
                            React.createElement(React.Fragment, null)),
                    React.createElement(Box, { gridRow: "2" }, t('Menu.home'))))),
        React.createElement(OSTooltip, { label: (!connected) ? t('Menu.sankeyOSPDisabled') : t('view.tooltips.buttonCreateViewUnitary') },
            React.createElement(Button, { variant: 'menutop_button', disabled: !connected, onClick: () => {
                    dict_hook_ref_setter_show_dialog_components.ref_setter_is_for_unitary_view.current(true);
                    dict_hook_ref_setter_show_dialog_components.ref_setter_show_unitary_view_modal.current(true);
                } },
                React.createElement(Box, { layerStyle: 'menutop_button_style' },
                    React.createElement(Box, { gridRow: "1", padding: "0.1rem 0 0.1rem 0" },
                        React.createElement(FontAwesomeIcon, { style: { 'height': '2rem', 'width': '3rem' }, icon: faSquarePlus }),
                        !connected ?
                            React.createElement(FontAwesomeIcon, { icon: faLock, style: {
                                    fontSize: '1em',
                                    position: 'absolute',
                                    right: '0.1em',
                                    bottom: '0em',
                                    color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                } }) :
                            React.createElement(React.Fragment, null)),
                    React.createElement(Box, { gridRow: "2" }, t('view.unit'))))),
        React.createElement(OSTooltip, { label: (!connected && !has_views) ? t('Menu.sankeyOSPDisabled') : t('view.tooltips.PrevViewButton') },
            React.createElement(Button, { variant: 'menutop_button', disabled: prev_button_disabled || !has_views, onClick: () => {
                    const ev = document;
                    const tmp = { key: 'F8' };
                    if (ev.onkeydown) {
                        ev.onkeydown(tmp);
                    }
                } },
                React.createElement(Box, { layerStyle: 'menutop_button_style' },
                    React.createElement(Box, { gridRow: "1", padding: "0.1rem 0 0.1rem 0" },
                        React.createElement(FontAwesomeIcon, { style: { 'height': '2rem', 'width': '3rem' }, icon: faCaretSquareLeft }),
                        (!connected && !has_views) ?
                            React.createElement(FontAwesomeIcon, { icon: faLock, style: {
                                    fontSize: '1em',
                                    position: 'absolute',
                                    right: '0.1em',
                                    bottom: '0em',
                                    color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                } }) :
                            React.createElement(React.Fragment, null)),
                    React.createElement(Box, { gridRow: "2" }, t('Menu.precView'))))),
        React.createElement(OSTooltip, { label: (!connected && !has_views) ? (t('Menu.sankeyOSPDisabled')) : t('view.tooltips.NextViewButton') },
            React.createElement(Button, { variant: 'menutop_button', disabled: next_button_disabled || !has_views, onClick: () => {
                    const ev = document;
                    const tmp = { key: 'F9' };
                    if (ev.onkeydown) {
                        ev.onkeydown(tmp);
                    }
                } },
                React.createElement(Box, { layerStyle: 'menutop_button_style' },
                    React.createElement(Box, { gridRow: "1", padding: "0.1rem 0 0.1rem 0" },
                        React.createElement(FontAwesomeIcon, { style: { 'height': '2rem', 'width': '3rem' }, icon: faCaretSquareRight }),
                        (!connected && !has_views) ?
                            React.createElement(FontAwesomeIcon, { icon: faLock, style: {
                                    fontSize: '1em',
                                    position: 'absolute',
                                    right: '0.1em',
                                    bottom: '0em',
                                    color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                } }) :
                            React.createElement(React.Fragment, null)),
                    React.createElement(Box, { gridRow: "2" }, t('Menu.nextView'))))),
        view_selector,
        (master_data ? master_data : { view: [] }).view.length > 0 && m_d.current_view !== 'none' && !window.SankeyToolsStatic ? React.createElement(React.Fragment, null,
            React.createElement(OSTooltip, { label: t('view.tooltips.button_delete_actual_view') },
                React.createElement(Button, { variant: 'menutop_button', disabled: !connected, onClick: 
                    // Delete the view
                    () => {
                        let ind = -1;
                        m_d.view.forEach((v, i) => {
                            ind = (v.id === view) ? i : ind;
                        });
                        m_d.view.splice(ind, 1);
                        // If master is not a catalog & we delete the current view then we go to master
                        // If master is a catalog and the catalog of view is empty then we got to master
                        if ((m_d.current_view === view && m_d.is_catalog === false) || (m_d.view.length === 0 && m_d.is_catalog === true)) {
                            set_view('none');
                            set_data(Object.assign({}, m_d));
                        }
                        else if (m_d.is_catalog && m_d.view.length > 0) {
                            // If master is a catalog and the catalog is not empty then we got to the first view
                            set_view(m_d.view[0].id);
                            const tmp = GetDataFromView(m_d, m_d.view[0].id);
                            set_data(Object.assign({}, tmp));
                        }
                        if (m_d.view.length === 0) {
                            m_d.is_catalog = false;
                            set_data(Object.assign({}, m_d));
                        }
                        set_master_data(Object.assign({}, m_d));
                    } },
                    React.createElement(Box, { layerStyle: 'menutop_button_style' },
                        React.createElement(Box, { gridRow: "1", padding: "0.1rem 0 0.1rem 0" },
                            React.createElement(FontAwesomeIcon, { style: { 'height': '2rem', 'width': '3rem' }, icon: faMinus }),
                            !connected ?
                                React.createElement(FontAwesomeIcon, { icon: faLock, style: {
                                        fontSize: '1em',
                                        position: 'absolute',
                                        right: '0.1em',
                                        bottom: '0em',
                                        color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                    } })
                                : React.createElement(React.Fragment, null)),
                        React.createElement(Box, { gridRow: "2" }, t('view.delete'))),
                    t('view.delete'))),
            React.createElement(OSTooltip, { label: t('view.tooltips.choose_link_ref_sankey_unit') },
                React.createElement(Button, { variant: 'menutop_button', onClick: () => dict_hook_ref_setter_show_dialog_components.ref_setter_show_modal_edit_link_reference_unitary.current(true) },
                    React.createElement(Box, { layerStyle: 'menutop_button_style' },
                        React.createElement(Box, { gridRow: "1", padding: "0.1rem 0 0.1rem 0" }, logo_unit_process_transfo),
                        React.createElement(Box, { gridRow: "2" }, t('view.choose_link_ref_sankey_unit'))))))
            : React.createElement(React.Fragment, null));
};
const NodesSelector = ({ selected_nodes, title, nodeSelected, data_for_selection, setForceUpdate, forceUpdate }) => {
    return React.createElement(Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols' },
        React.createElement(Box, { as: 'span', layerStyle: 'menuconfigpanel_part_title_2' }, title),
        React.createElement(MultiSelect, { className: 'multidropdown_select_link_ref', labelledBy: 'dropdown_link_filter', overrideStrings: {
                'selectAll': 'Tout sélectionner',
            }, value: selected_nodes.current
                .filter(n => nodeSelected(n))
                .map(n => { return { 'label': n.name, 'value': n.idNode }; }), options: Object.values(data_for_selection.nodes)
                .filter(n => nodeSelected(n) &&
                n.inputLinksId.length > 0 && n.outputLinksId.length > 0 &&
                NodeHasDisplayedLevel(data_for_selection, n))
                .map(n => {
                return { 'label': n.name, 'value': n.idNode };
            }), onChange: (selected) => {
                selected_nodes.current = selected.map(s => data_for_selection.nodes[s.value]);
                setForceUpdate(!forceUpdate);
            } }));
};
export const UnitarySankeyCreationDialog = ({ applicationContext, applicationState, applicationData, processFunctions, applicationDraw, convert_data, dict_hook_ref_setter_show_dialog_components }) => {
    const selected_products = useRef([]);
    const selected_sectors = useRef([]);
    const [is_for_unitary_view, set_is_for_unitary_view] = useState(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_is_for_unitary_view.current = set_is_for_unitary_view;
    const [excel_file_to_load, set_excel_file_to_load] = useState(undefined);
    const [file_name, set_file_name] = useState('');
    const [last_selected_file, set_last_selected_file] = useState();
    const [data_source_for_unitary, set_data_source_for_unitary] = useState({ 'app_data': applicationData.data });
    const [forceUpdate, setForceUpdate] = useState(false);
    const [from_excel, set_from_excel] = useState(false);
    // Data from wich we will select nodes to create unitary views
    const [data_for_selection, set_data_for_selection] = useState(data_source_for_unitary['app_data']);
    if (Object.keys(data_for_selection.nodes).length == 0 && Object.keys(applicationData.data.nodes).length > 0) {
        data_source_for_unitary['app_data'] = applicationData.data;
        set_data_source_for_unitary(data_source_for_unitary);
        set_data_for_selection(data_source_for_unitary['app_data']);
    }
    const show_unitary_modal = useState(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_unitary_view_modal.current = show_unitary_modal[1];
    const [result, set_result] = useState('');
    processFunctions.ref_result.current = set_result;
    // Only take sector and product if it has 'Type de noeud' tag else all nodes are selectable
    // const has_node_type = Object.values(data_for_selection.nodeTags).filter(t => t.group_name === 'Type de noeud').length > 0
    // const pre_filter_node = (has_node_type) ? Object.keys(data_for_selection.nodeTags['Type de noeud'].tags) : []
    // const [filter_node_selector, set_filter_node_selector] = useState<string[]>(pre_filter_node)
    const [is_computing, set_is_computing] = useState(false);
    const local_launch = (path) => {
        processFunctions.path.current = path;
        processFunctions.ref_setter_processing.current(true);
        processFunctions.ref_processing.current = true;
        processFunctions.failure.current = true;
        processFunctions.not_started.current = false;
        processFunctions.ref_result.current('');
        setForceUpdate(!forceUpdate);
    };
    const path = window.location.origin;
    // Process data received after loading the excel file in the server
    if (is_for_unitary_view && !processFunctions.not_started.current && !processFunctions.ref_processing.current) {
        const url = path + applicationContext.url_prefix + 'loads_retrieves_result';
        const form_data = new FormData();
        const fetchData = {
            method: 'POST',
            body: form_data
        };
        fetch(url, fetchData).then(response => {
            response.text().then(text => {
                const server_data = JSON.parse(text);
                const new_data = Object.assign(applicationData.get_default_data(), server_data);
                complete_sankey_data(new_data, applicationData.get_default_data, DefaultNode, DefaultLink);
                convert_data(new_data, applicationData.get_default_data);
                compute_default_input_outputLinksId(new_data.nodes, new_data.links);
                SplitTrade(new_data);
                compute_default_input_outputLinksId(new_data.nodes, new_data.links);
                //applicationData.data = server_data
                //ProcessExample(applicationData, applicationDraw.updateLayout, convert_data, applicationData.get_default_data)
                delete new_data.layout;
                // Add the loaded excel to the list of data used in the modale that create unit view from excel file
                data_source_for_unitary[file_name] = new_data;
                if (last_selected_file === undefined) {
                    set_last_selected_file(file_name);
                    set_data_for_selection(new_data);
                }
                set_data_source_for_unitary(Object.assign({}, data_source_for_unitary));
            }).then(() => {
                set_is_computing(false);
            });
        });
        processFunctions.ref_processing.current = false;
        processFunctions.failure.current = false;
        processFunctions.not_started.current = true;
    }
    // Icon About state of excel process
    const spinner = (processFunctions.ref_processing.current || is_computing) ? React.createElement(Spinner, null) : React.createElement(React.Fragment, null);
    const load_error = (!processFunctions.ref_processing.current && processFunctions.failure.current) ? React.createElement(Tag, null,
        React.createElement(FontAwesomeIcon, { fontVariant: 'primary', icon: faCircleExclamation })) : React.createElement(React.Fragment, null);
    //const hierarchy_nodes = tree_data_nodes(data_for_selection, filter_node_selector, filter_name, selected_nodes_for_unitary_view.current)
    const dialog = MenuDraggable(dict_hook_ref_setter_show_dialog_components, 'showUnitarySankeyCreationDialog', React.createElement(Modal
    // variant='modal_select_unit_from_excel'
    , { 
        // variant='modal_select_unit_from_excel'
        isOpen: show_unitary_modal[0], onClose: () => {
            set_is_for_unitary_view(false);
            show_unitary_modal[1](false);
        } },
        React.createElement(ModalContent, { maxWidth: 'inherit' },
            React.createElement(ModalHeader, null, applicationContext.t('view.create_unit')),
            React.createElement(ModalBody, null,
                React.createElement(Box, { layerStyle: 'menuconfigpanel_grid' },
                    React.createElement(Checkbox, { variant: 'menuconfigpanel_option_checkbox', isChecked: from_excel, onChange: (evt) => {
                            set_from_excel(evt.target.checked);
                            if (evt.target.checked) {
                                set_data_source_for_unitary({});
                            }
                            else {
                                set_data_source_for_unitary({ 'app_data': applicationData.data });
                            }
                        } }, "Depuis fichier excel")),
                React.createElement(Box, { layerStyle: 'menuconfigpanel_grid' },
                    from_excel ? React.createElement(React.Fragment, null,
                        React.createElement(Box, { as: 'span', layerStyle: 'menuconfigpanel_part_title_2' },
                            applicationContext.t('view.select_excel_file'),
                            " ",
                            spinner,
                            " ",
                            load_error),
                        processFunctions.ref_processing.current ? (React.createElement(Counter, { url_prefix: applicationContext.url_prefix, finishReconciliation: () => {
                                processFunctions.ref_processing.current = false;
                                set_is_computing(true);
                                processFunctions.failure.current = false;
                            }, value: [1, 2, 3], result: result, set_result: set_result })) : React.createElement(React.Fragment, null),
                        React.createElement(Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols' },
                            React.createElement(Input, { type: "file", accept: '.xlsx,.xlsm,.xls', onChange: (evt) => {
                                    if (evt.target.files.length > 0) {
                                        set_file_name(evt.target.files[0].name);
                                        set_excel_file_to_load(evt.target.files[0]);
                                    }
                                    else {
                                        set_file_name('');
                                        set_excel_file_to_load(undefined);
                                    }
                                } }),
                            React.createElement(Button, { variant: "primary", disabled: excel_file_to_load === undefined, onClick: () => {
                                    if (excel_file_to_load) {
                                        // Upldoad excel to server for process
                                        const root = window.location.origin;
                                        const url = root + applicationContext.url_prefix + 'sankey/upload_excel';
                                        const form_data = new FormData();
                                        form_data.append('file', excel_file_to_load);
                                        const fetchData = {
                                            method: 'POST',
                                            body: form_data
                                        };
                                        fetch(url, fetchData).then(response => {
                                            local_launch('');
                                        });
                                    }
                                } }, applicationContext.t('Menu.ouvrir')))) : React.createElement(React.Fragment, null),
                    Object.keys(data_source_for_unitary).length > 0 ? React.createElement(React.Fragment, null,
                        React.createElement("hr", null),
                        React.createElement(Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols' },
                            React.createElement(Box, { layerStyle: 'menuconfigpanel_option_name' }, applicationContext.t('view.select_data_source')),
                            React.createElement(Box, { layerStyle: 'options_2cols' },
                                React.createElement(Select, { value: last_selected_file, onChange: (evt) => {
                                        selected_products.current = [];
                                        selected_sectors.current = [];
                                        set_last_selected_file(evt.target.value);
                                        set_data_for_selection(data_source_for_unitary[evt.target.value]);
                                    } }, Object.entries(data_source_for_unitary).map(([k,]) => React.createElement("option", { key: k, value: k }, k))),
                                React.createElement(Button, { variant: 'menuconfigpanel_del_button', disabled: !last_selected_file || last_selected_file === 'app_data', onClick: () => {
                                        if (last_selected_file && last_selected_file !== 'app_data') {
                                            delete data_source_for_unitary[last_selected_file];
                                            set_data_source_for_unitary(data_source_for_unitary);
                                            selected_products.current = [];
                                            selected_sectors.current = [];
                                            if (Object.keys(data_source_for_unitary).length > 1) {
                                                const first_file_of_list = Object.keys(data_source_for_unitary)[1];
                                                set_last_selected_file(first_file_of_list);
                                                set_data_for_selection(data_source_for_unitary[first_file_of_list]);
                                            }
                                            else {
                                                set_last_selected_file(undefined);
                                                set_data_for_selection(data_source_for_unitary['app_data']);
                                            }
                                        }
                                    } },
                                    React.createElement(FontAwesomeIcon, { icon: faTrashCan })))),
                        React.createElement(Popover, { placement: 'left', id: 'popover_details_level' },
                            React.createElement(PopoverTrigger, null,
                                React.createElement(Button, { variant: 'toolbar_button_2', id: 'btn_open_popover_details_level' },
                                    React.createElement(FontAwesomeIcon, { icon: faFolderTree }))),
                            React.createElement(PopoverContent, null,
                                React.createElement(PopoverArrow, null),
                                React.createElement(PopoverCloseButton, null),
                                React.createElement(PopoverHeader, null, applicationContext.t('Banner.ndd')),
                                React.createElement(PopoverBody, { style: { maxHeight: '600px', overflowY: 'auto' } },
                                    React.createElement(React.Fragment, null, (Object.entries(data_for_selection.levelTags).length > 0) ? (React.createElement(React.Fragment, null, React.createElement(AddAllDropDownNode, { applicationContext: applicationContext, set_data_for_selection: set_data_for_selection, data: data_for_selection }))) : (React.createElement(React.Fragment, null,
                                        React.createElement(Input, { placeholder: "Pas de filtrage", isDisabled: true }))))))),
                        'Type de noeud' in data_for_selection.nodeTags ?
                            React.createElement(React.Fragment, null,
                                React.createElement(NodesSelector, { selected_nodes: selected_products, title: 'Produits', nodeSelected: ((n) => 'Type de noeud' in n.tags && n.tags['Type de noeud'][0] == 'produit'), data_for_selection: data_for_selection, setForceUpdate: setForceUpdate, forceUpdate: forceUpdate }),
                                React.createElement(NodesSelector, { selected_nodes: selected_sectors, title: 'Secteurs', nodeSelected: ((n) => 'Type de noeud' in n.tags && n.tags['Type de noeud'][0] == 'secteur'), data_for_selection: data_for_selection, setForceUpdate: setForceUpdate, forceUpdate: forceUpdate })) : React.createElement(NodesSelector, { selected_nodes: selected_products, title: 'Noeuds', nodeSelected: () => true, data_for_selection: data_for_selection, setForceUpdate: setForceUpdate, forceUpdate: forceUpdate })) : React.createElement(React.Fragment, null))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { variant: 'menuconfigpanel_del_button', onClick: () => {
                        show_unitary_modal[1](false);
                    } }, applicationContext.t('Menu.close')),
                React.createElement(Button, { variant: 'primary', disabled: selected_products.current.length === 0 && selected_sectors.current.length === 0, onClick: () => {
                        if (applicationData.master_data === undefined) {
                            applicationData.master_data = JSON.parse(JSON.stringify(applicationData.data));
                        }
                        applicationData.data = data_for_selection;
                        applicationData.display_nodes = data_for_selection.nodes;
                        applicationData.display_links = data_for_selection.links;
                        if (Object.values(applicationData.data.nodes).length === 0) {
                            return;
                        }
                        selected_products.current.forEach(n => {
                            CreateViewNodeUnitary(applicationContext.t, applicationData, n, false, // from_zdd
                            last_selected_file.replace('_reconciled', '').replace('.xlsx', ''));
                        });
                        selected_sectors.current.forEach(n => {
                            CreateViewNodeUnitary(applicationContext.t, applicationData, n, false, // from_zdd
                            last_selected_file.replace('_reconciled', '').replace('.xlsx', ''));
                        });
                        applicationData.set_master_data(Object.assign({}, applicationData.master_data));
                        applicationData.set_data(Object.assign({}, applicationData.master_data));
                        selected_products.current = [];
                        selected_sectors.current = [];
                        applicationState.multi_selected_nodes.current = [];
                        show_unitary_modal[1](false);
                    } }, applicationContext.t('view.create'))))), { current: [window.innerWidth / 4, window.innerHeight / 4] }, 'title');
    return dialog;
};
export const AddAllDropDownNode = ({ data, set_data_for_selection, applicationContext }) => {
    const { t } = applicationContext;
    const { levelTags } = data;
    const [forceUpdate, setForceUpdate] = useState(false);
    let banner_grouptag;
    const nb_level_tag = Object.values(levelTags).filter(tags_group => (Object.keys(tags_group.tags).length > 0)).length;
    if (nb_level_tag > 1) {
        banner_grouptag = Object.entries(levelTags).filter(([, tags_group]) => tags_group.group_name !== 'Primaire' && Object.keys(tags_group.tags).length > 0);
        data.levelTags['Primaire'].activated = false;
    }
    else {
        banner_grouptag = Object.entries(levelTags).filter(([, tags_group]) => Object.keys(tags_group.tags).length > 1);
    }
    // Function that redraw node & links
    // used when we activate/deactivate tag color palette
    const allDD = banner_grouptag.map(([, tags_group]) => {
        // Create a btn that can either be a switch to activate tag color palette
        // or in some case for level tag activating or deactivating antagonazing tags
        let btn_switch = React.createElement(React.Fragment, null);
        if (tags_group.siblings !== undefined && tags_group.siblings.length > 0) {
            btn_switch = React.createElement(Checkbox, { justifySelf: 'end', alignSelf: 'center', variant: 'activate_antagonist_checkbox', isChecked: tags_group.activated, icon: tags_group.activated ? React.createElement(FaEye, { style: { fill: 'rgb(120, 194, 173)' } }) : React.createElement(FaEyeSlash, null), onChange: evt => {
                    tags_group.activated = evt.target.checked;
                    const first_antagonist_tag = data.levelTags[tags_group.siblings[0]];
                    // Respectively activate and desactivate in the two antagonist tags  group
                    // Same as of current tag group
                    first_antagonist_tag.siblings.forEach(sibling => data.levelTags[sibling].activated = tags_group.activated);
                    // Opposed to current tag group
                    tags_group.siblings.forEach(sibling => data.levelTags[sibling].activated = !tags_group.activated);
                    setForceUpdate(!forceUpdate);
                    set_data_for_selection(Object.assign({}, data));
                } });
        }
        // Create the tag selector
        // It can either select one tag at the time or multiple at the time
        let selector = React.createElement(React.Fragment, null);
        if (tags_group.banner === 'level' && Object.values(tags_group.tags).length > 0) {
            if (Object.keys(tags_group.tags).length < 1) {
                return React.createElement(React.Fragment, null);
            }
            const tmp = Object.entries(tags_group.tags).filter(tag => tag[1].selected);
            const selected = tmp.length > 0 ? tmp[0][0] : '';
            selector = React.createElement(Select, { key: tags_group.group_name, value: selected, onChange: (evt) => {
                    const val = evt.target.value;
                    Object.entries(tags_group.tags).forEach(tag => tag[1].selected = val === tag[0]);
                    set_data_for_selection(Object.assign({}, data));
                    setForceUpdate(!forceUpdate);
                } }, Object.entries(tags_group.tags).map(([tag_key, tag], i) => {
                return (React.createElement("option", { key: i, value: tag_key }, tag.name));
            }));
        }
        return (React.createElement(Box, { layerStyle: 'menuconfig_grid' },
            React.createElement(Box, { layerStyle: 'menuconfigpanel_option_name' }, tags_group.group_name),
            React.createElement(Box, { layerStyle: 'popover_sidebar_row_tag_filter' },
                React.createElement(OSTooltip, { label: t('Banner.ndd_lst') }, selector),
                React.createElement(OSTooltip, { label: t('Banner.ndd_chk') },
                    React.createElement(Box, { justifySelf: 'end' }, btn_switch)))));
    });
    return (React.createElement(React.Fragment, null, allDD));
};
